import styled from 'styled-components';

export const DocumentsScope = styled.div`
  width: 100%;
  margin: 14px 0 8px;

  .document-group {
    width: 100%;
    overflow: visible !important;
    padding: 0 !important;
    background: transparent;
  }

  .document-group + .document-group {
    margin-top: 18px;
  }

  .document-group-title {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 10px;
    padding: 0 0 0 10px !important;
    border-left: 3px solid #24a95d;
    color: #3f3f3f;
    overflow-wrap: anywhere;
  }

  .document-group-title p {
    margin: 0;
    color: inherit;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }

  .document-item {
    width: 100% !important;
    margin: 0 0 8px !important;
    padding: 12px !important;
    border: 1px solid #e2e6e9;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }

  .document-main {
    display: grid !important;
    grid-template-columns: 40px minmax(0, 1fr);
    gap: 10px 12px;
    width: 100%;
    align-items: start !important;
  }

  .document-switch {
    grid-column: 1;
    display: flex;
    align-items: center;
    padding-top: 3px !important;
  }

  .document-name {
    grid-column: 2;
    min-width: 0;
  }

  .document-name button {
    justify-content: flex-start;
    width: 100%;
    height: auto !important;
    padding: 0;
    color: #168a4a;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .document-validity {
    grid-column: 2;
    display: flex;
    flex: initial !important;
    align-items: center;
    gap: 8px;
    min-width: 0 !important;
    color: #595959;
    font-size: 13px;
    font-weight: 600;
  }

  .document-validity .ant-input {
    width: 120px !important;
  }

  .document-confirm {
    grid-column: 2;
    flex: initial !important;
  }

  .document-observation {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: auto;
    margin: 10px 0 0 52px;
    padding: 8px 10px;
    border-left: 3px solid #cbd2d8;
    border-radius: 0 4px 4px 0;
    background: #f7f8f9;
    color: #4f4f4f;
    font-size: 13px;
    line-height: 18px;
    overflow-wrap: anywhere;
  }

  .document-observation:empty {
    display: none;
  }

  .document-observation b {
    color: #595959;
    font-size: 12px;
  }

  @media (max-width: 576px) {
    .document-observation {
      margin-left: 0;
    }
  }
`;

export const DocumentGroups = styled.div`
  width: 100%;
`;
